import { createStore } from 'vuex'
import store from "store2"
import {
    getInit,
    getArticles,
    getTopAtricles,
    getRecommendAtricles,
    getLunbo
} from "../sdk/sdk";
import { Toast } from 'vant';

// TODO:增加更高级的缓存机制(加快页面构建速度)

// Create a new store instance.
export default createStore({
    state() {
        return {
            // 初始化是否结束
            initOver: false,
            tags: [],
            list_info: [],
            // 首页列表
            top_list_info: [],
            top_list_info2: [],
            recommend_list_info: {},
            lun_bo: {}
        }
    },
    mutations: {
        handleInitTags(state, data) {
            state.tags = data
        },
        InitOver(state) {
            state.initOver = true
        },
        handleList(state, list_info) {
            const channel_item = state.list_info.findIndex(e => e.channelId == list_info.channelId);

            // 先查找是否已经存有数据
            if (channel_item != -1) {
                // 如果已有数据的话,查看page是否为1,为1代表清空数据(也就是重新加载)
                if (list_info.page == 1) {
                    state.list_info[channel_item] = list_info
                } else {
                    const temp_list = state.list_info[channel_item].list;
                    state.list_info[channel_item] = list_info;
                    // 将之前数据推入数据
                    state.list_info[channel_item].list = [...temp_list, ...list_info.list]
                }
            } else {
                // 否则就添加
                state.list_info.push(list_info)
            }
        },
        // 初始化首页data
        handleFirstPage(state, list_info) {
            state.top_list_info = list_info.top_list_info;
            state.top_list_info2 = list_info.top_list_info2;
        },

        handleFirstPageList(state, list_info) {
            // 先看是否有数据,处理没有数据和page为1的时候
            if (!state.recommend_list_info.page || list_info.page == 1) {
                state.recommend_list_info = list_info
            } else {
                // 处理有page的时候
                const temp_list = state.recommend_list_info.list;
                state.recommend_list_info = list_info;
                // 将之前数据推入数据
                state.recommend_list_info.list = [...temp_list, ...list_info.list]
            }
        },
        handleLunbo(state, list_info) {
            state.lun_bo = list_info;
        }
    },
    getters: {

    },
    actions: {
        // 进行一些初始化操作
        async getInit({ dispatch, commit }) {
            // 并行加载接口优化加载速度
            await Promise.all([dispatch('getInitTags'), dispatch('getFirstPageInit'), dispatch('getLunbo')])
            // 最后结束骨架屏状态
            commit('InitOver')

        },
        async getInitTags({ commit }) {
            if (store.session.has('tags')) {
                commit('handleInitTags', store.session('tags'));
            } else {
                const data = await getInit();
                if (data.state == 1) {
                    // 手机映象网下的栏目里稿件
                    console.log("获取首页全部数据", data)
                    commit('handleInitTags', data.data);
                    store.session('tags', data.data);
                } else {
                    // 进行一些错误处理
                    Toast.fail('加载失败！请检查网络！');
                }
            }

        },
        // 获取列表数据
        async getListData({ commit, state }, { channelId, page = 1 }) {
            //这里如果是第一页而且当前state当中还没有内容的话，就是证明初始化加载

            if (!state.list_info.find(e => e.channelId == channelId)) {
                Toast.loading({
                    duration: 0,
                    message: '加载中...',
                    forbidClick: true,
                });
            }

            const data = await getArticles(channelId, page);
            Toast.clear();
            if (data.state == 1) {
                commit('handleList', data.data)
            } else {
                console.log(data)
                // 进行一些错误处理
                Toast.fail('加载失败！请检查网络！1');
            }

        },
        // 获取首页接口数据
        async getFirstPageInit({ commit, dispatch }, { cache = true } = {}) {

            let top_data;

            if (cache && store.session.has('getTopAtricles')) {
                top_data = store.session('getTopAtricles');
            } else {
                top_data = await getTopAtricles();
                store.session('getTopAtricles', top_data);
            }

            await dispatch('getRecommendList', { cache });

            if (top_data.state == 1) {
                commit('handleFirstPage', {
                    top_list_info: top_data.data,
                });
            } else {
                console.log(top_data)
                // 进行一些错误处理
                Toast.fail('加载失败！请检查网络！2');
            }
        },
        // 获取首页推荐接口数据
        async getRecommendList({ commit }, { page = 1, cache = true } = {}) {
            // 如果需要缓存
            if (cache && store.session.has('recommend_list_info') && store.session('recommend_list_info').page == page) {
                commit('handleFirstPageList', store.session('recommend_list_info'));
            } else {
                const data = await getRecommendAtricles(page);
                if (data.state == 1) {
                    commit('handleFirstPageList', data.data)
                    store.session('recommend_list_info', data.data)
                } else {
                    console.log(data)
                    // 进行一些错误处理
                    Toast.fail('加载失败！请检查网络！3');
                }
            }
        },
        // 获取首页轮播图
        async getLunbo({ commit }) {
            if (store.session.has('lun_bo')) {
                commit('handleLunbo', store.session('lun_bo'));
            } else {
                const data = await getLunbo();
                if (data.state == 1) {
                    commit('handleLunbo', data.data)
                    store.session('lun_bo', data.data)
                } else {
                    console.log(data)
                    // 进行一些错误处理
                    Toast.fail('加载失败！请检查网络！157');
                }
            }
        },
    }
})